module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_13.1c35eb2f.jpg";